import Select from 'react-select';

import { ReactComponent as CalendarIcon } from '../../static/calendar_icon.svg';
import {
  activeFiltersActions,
  FilterOption,
  useActiveFilters
} from '../../context/active-filter-context';
import styles from './seasonSelect.module.scss';

interface IProps {
  options: FilterOption[];
  isSearchable?: boolean;
}

const SeasonSelect = ({ options, isSearchable = false }: IProps) => {
  const { state, dispatch } = useActiveFilters();

  const customStyles = {
    clearIndicator: (provided: any, state: any) => ({
      ...provided
    }),
    container: (provided: any, state: any) => ({
      ...provided
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: 'none',
      border: 'none !important',
      boxShadow: 'none',
      padding: '0',
      cursor: 'pointer'
    }),
    dropdownIndicator: (provided: any, state: any) => ({
      ...provided
    }),
    group: (provided: any, state: any) => ({
      ...provided
    }),
    groupHeading: (provided: any, state: any) => ({
      ...provided
    }),
    indicatorsContainer: (provided: any, state: any) => ({
      ...provided,
      path: {
        fill: 'white'
      }
    }),
    indicatorSeparator: (provided: any, state: any) => ({
      ...provided,
      display: 'none'
    }),
    input: (provided: any, state: any) => ({
      ...provided,
      margin: '0',
      padding: '0'
    }),
    loadingIndicator: (provided: any, state: any) => ({
      ...provided
    }),
    loadingMessage: (provided: any, state: any) => ({
      ...provided
    }),
    menu: (provided: any, state: any) => ({
      ...provided,
      border: '1px solid #94999e',
      borderRadius: '0',
      boxShadow: 'none',
      padding: '16px 0',
      width: '200px',
      margin: 0,
      right: 0,
      zIndex: 2
    }),
    menuList: (provided: any, state: any) => ({
      ...provided,
      border: 'none'
    }),
    menuPortal: (provided: any, state: any) => ({
      ...provided
    }),
    multiValue: (provided: any, state: any) => ({
      ...provided
    }),
    multiValueLabel: (provided: any, state: any) => ({
      ...provided
    }),
    multiValueRemove: (provided: any, state: any) => ({
      ...provided
    }),
    noOptionsMessage: (provided: any, state: any) => ({
      ...provided
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#f6f7f9' : '#fff',
      backgroundImage: state.isSelected
        ? "url('data:image/webp;base64,UklGRvoAAABXRUJQVlA4WAoAAAAQAAAAGQAAGQAAQUxQSFYAAAABZ2AgksykT2Ab0ICIiFqXjnmAaW3tTb7QQYHtDFS3wGYAFkHio5igd8Yiv4uP6P8EQLmNQ1o9Si4YZYzwnzP4jyaZQgwFpFwEjyXD2Xcg8s+moIVqAVZQOCB+AAAAkAQAnQEqGgAaAD5lKI9FpCKhG/1UAEAGRLYAX6MQBvCwIDl9Su9oguhRpL4AAP74CW//9tkiKRVY4XOf5xHo67cO+//S+5+Za9R/cl/DR+iwKYFl2dsIRURLpyB+XqHtP9/PnV4DNf/oUGEvN0mhY6OLTt39RlJ797qyMmAA')"
        : 'none',
      backgroundPosition: '90% center',
      backgroundRepeat: 'no-repeat',
      color: '#2b363b',
      font: 'normal 400 14px "Roboto", Arial, Helvetica, sans-serif',
      padding: '10px 24px',
      cursor: 'pointer',
      '&:active': {
        backgroundColor: '#f6f7f9'
      }
    }),
    placeholder: (provided: any, state: any) => ({
      ...provided
    }),
    singleValue: (provided: any, state: any) => {
      return {
        ...provided,
        fontFamily: 'Roboto',
        fontSize: 14,
        margin: '0',
        padding: '0',
        fontWeight: 'bold',
        color: 'white'
      };
    },
    valueContainer: (provided: any, state: any) => ({
      ...provided,
      padding: '0'
    })
  };

  return (
    <>
      <div className={styles.seasonSelect}>
        <div className={styles.container}>
          <CalendarIcon />
          <label id="season-filter" className={styles.seasonLabel}>
            Display season:{' '}
          </label>
          <Select
            data-testid="PT-filterSelectSeason-seasonSelect"
            aria-labelledby="season-filter"
            options={options}
            value={state.season}
            isSearchable={isSearchable}
            styles={customStyles}
            onChange={e => {
              dispatch(activeFiltersActions.setSeason(e as FilterOption));
              sessionStorage.setItem('season', JSON.stringify(e));
            }}
          />
        </div>
      </div>
    </>
  );
};

export default SeasonSelect;
